import { render, staticRenderFns } from "./BrightsignResult.vue?vue&type=template&id=e57a5c3a&scoped=true&"
import script from "./BrightsignResult.vue?vue&type=script&lang=js&"
export * from "./BrightsignResult.vue?vue&type=script&lang=js&"
import style0 from "./BrightsignResult.vue?vue&type=style&index=0&id=e57a5c3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57a5c3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
